import { BrowserRouter as Router, useLocation, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import NavBar from './components/NavBar';
import Footer from './components/Footer';
import ScrollToTop from './pages/ScrollToTop';

import Home from './pages/Home';
import Programs from './pages/Programs';
import Blogs from './pages/Blogs';
import Error from './pages/Error';
import Connect from './pages/Connect';
import BlogPost from './components/BlogPost';
import Company from './pages/Company';

import './App.css';

// Split AnimatedRoutes to make use of `useLocation`
function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<Company />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/post" element={<BlogPost />} />
        <Route path="/connect" element={<Connect />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </AnimatePresence>
  );
}

function AppWrapper() {
  return (
    <Router>
      <ScrollToTop />
      <NavBar />
      <AnimatedRoutes />
      <Footer />
    </Router>
  );
}

export default AppWrapper;
















// import NavBar from './components/NavBar';
// import Footer from './components/Footer';
// import Home from './pages/Home';
// import Programs from './pages/Programs';
// import Blogs from './pages/Blogs';
// import Error from './pages/Error';
// import Connect from './pages/Connect';
// import BlogPost from './components/BlogPost';
// import Company from './pages/Company';

// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import { AnimatePresence } from "framer-motion";


// import './App.css';
// import ScrollToTop from './pages/ScrollToTop';

// function App() {
//   return (
//     <Router>
//       <ScrollToTop />
//       <NavBar />
//       <Routes>
//         <Route path='/' element={<Home />} />
//         <Route path='/about' element={<Company />} />
//         <Route path='/programs' element={<Programs />} />
//         <Route path='/blogs' element={<Blogs />} />
//         <Route path='/post' element={<BlogPost />} />
//         <Route path='/connect' element={<Connect />} />
//         <Route path='*' element={<Error />} />
//       </Routes>
//       <Footer />
//     </Router>
//   )
// }

// export default App;
